<a attr.aria-label="Link-{{aggregate}}-ProjectAccounting" class="no-underline no-vertical-pad">
    <aggregate-card [aggregate]="aggregate" [aggregateCriteria]="aggregateCriteria" [chartConfiguration]="chartConfiguration" icon="monetization_on">
    </aggregate-card>
</a>
